/*
Lalitha 12/19/2022  3075154998 Added Search Data Manager Table
Sohel  12/19/2022 3075154998 removed fields
Lalitha 12/19/2022  3075154998 Added Created Date Data Manager Table
Sohel 12/23/2022 3075154998 Integrated Data Manager Search API
Sohel 12/23/2022 3075154998 Integrated Basic Info API.
Sohel 12/23/2022 3075154998 Integrated Delete API.
Sohel 12/28/2022 3075154998 Added edit icon.
Sohel 04/01/2023 3075154998 changed column label name.
dilip 06/01/2023 3075154998 reset map records data.
dilip 06/01/2023 3075154998 Added type parameter.
dilip 01/09/2023 3075154998 Added Search data session storage functionality
Sohel 01/09/2023 2698951347 Implemented Copy Functionality
Sohel 01/09/2023 3075154998 Added conditionally Search data session storage functionality
Dilip 01/09/2023 3075154998 Implemented System Notes Functionality
Sohel 01/10/2023 3075154998 pass Type in Payload
kavyareddy 01/10/2023 3075154998 Fixed column and delete issue
kavyareddy 01/10/2023 3075154998 Added download configuration
Sohel 01/12/2023 3075154998 changed download configuration condition
dilip 01/12/2023 3075154998 Reset parent record value.
Dilip 01/13/2023 3075154998 disabled download on no records
Dilip 01/13/2023 3075154998 addded code in delete popup
Sohel 01/18/2023 3075154998 fixed reset Issue
Sohel 01/18/2023 3075154998 Download Configuration Payload Changes
sai krishna 01/20/2023 3075154998 renamed notes tooltip
sai krishna 01/23/2023 3075154998  fixed tooltip issue
Dilip 01/30/2023 3075154998  added execution history functionality
Dilip 02/09/2023 3075154998 added created for, created by dropdown
Sohel 02/09/2023 3075154998 Fixed createdBy issue
Dilip 02/10/2023 3075154998 changed Column Positions
sai krishna 02/13/2023 3075154998 added client code in table
Guru Prasad 02/13/2023 3075154998 Added tooltip for the client code
Dilip 02/21/2023 3075154998 Added client code in download payload
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
Ravi 02/23/2023 2780168262 implemented test functionality
Akhila 02/27/2023 2780168262 implemented preview file functionality
Dilip 02/27/2023 3075154998 Fixed Sorting issue
Akhila 02/27/2023 2780168262 added createdBy in payload for download configuration
Suresh Peddavoora 03/15/2023 2780168262 Added Dropdown menu in Action Column in table
Akhila 03/17/2023 3075154998 download toast message and loader in preview file
Akhila 03/2/2023 3075154998 bug fix delete code issue in delete popup
Raghu 03/04/2023 3075154998 added plus icon
Akhila 05/04/2023 3075154998 Added update date column and in payload
Sohel 05/17/2023 3075154998 Add Import File Functionality
Akhila 05/17/2023 3075154998 Added Export File Functionality
Sohel 05/22/2023 3075154998 Added Imports and Exports in Schedular
Sohel 05/23/2023 3075154998 Changed Import Test Title
Ravi 05/31/2023 3075154998  changed delete popup message
Sohel 06/01/2023 2692790263 disable Executions and run in draft mode
Akhila 06/06/2023 3075154998 added code and description in action
Akhila 06/06/2023 3075154998 title change for view and configuration for execution
Akhila 06/07/2023 3075154998 change code and description in test and import file action menu
Akhila 06/08/2023 3075154998 rearrange the column and form fields
Akhila 06/12/2023 3075154998 added role access
Ravi 06/27/2023 3075154998  fixed basicInfoData reset issue
*/

import React, {createRef, useState, useEffect, useRef} from 'react';
import {TablePagination, Grid, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../constants/ReusableConstants';
import {httpGet, httpPaginationPost} from '../../../util/Rest';
import {useDispatch} from 'react-redux';
import {
  fetchBasicInfoData,
  resetBasicInfo,
  resetDataManager,
  resetRecordData,
  setParentRecordException,
  resetConfigUrl,
  resetDockey,
} from '../../../redux/reducers/EDI/index';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import DialogBox from '../../../components/DialogBox';
import CopyDataManager from './CopyDataManager';
import {useSelector} from 'react-redux';
import DmNotes from './DmNotes';
import PageLoader from '../../../components/PageLoader';
import {resetDataManagerRecord} from '../../../redux/reducers/DataManagerRecord';
import DmExecutionTable from './DmExecutionTable';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../redux/reducers/ReportMaster';
import SaveIcon from '@material-ui/icons/Save';
import EnableTestDialoge from './EnableTestDialoge';
import ActionMenuItem from '../../../util/ActionMenuItem';
import PreviewFileDialog from '../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../redux/reducers/PreviewFileData';
import ExportFile from './ExportFile';
import BreadCrums from '../../../util/BreadCrum';

const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
function SearchDMTable({
  setValue,
  searchData,
  submit,
  setSubmit,
  exportManager,
  isSchedular = false,
  setDMCode = () => {},
  setIsCodeSearch = () => {},
  setEditExisting = () => {},
  DataManagerAccess,
  setDmTableData = () => {},
}) {
  const tableRef = createRef();
  const classes1 = useStyles();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [copyDataManager, setCopyDataManager] = useState(false);
  const [oldDmCodeData, setOldDmCodeData] = useState(null);
  const {
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    addBasicInfoStatus,
    isBasicInfoLoading,
    configurationUrl,
    dockey,
    exportFileSuccessMsg,
  } = useSelector(({ediExport}) => ediExport);

  const deletedId = useRef(null);
  const rowDataRef = useRef();
  const queryRef = useRef(null);
  const dispatch = useDispatch();
  const type = exportManager ? 'Export' : 'Import';
  const [isNote, setIsNote] = useState(false);
  const [dmData, setDmData] = useState();
  const [dmExecution, setDmExecution] = useState(false);
  const [testOpen, setTestOpen] = useState(false);
  const [importFileOpen, setImportFileOpen] = useState(false);
  const [exportFileOpen, setExportFileOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const columns = [
    {
      title: 'Code',
      field: 'exportCode',
      render: (rowData) => (
        <div
          style={{
            maxWidth: 300,
            textAlign: 'left',
          }}
        >
          <span
            role="button"
            className={classes1.link}
            onClick={() => {
              dispatch(fetchBasicInfoData({code: rowData?.exportCode}));
              setValue(1);
              setEditExisting(exportManager ? 'Export Manager' : 'Import Manager');
            }}
          >
            {rowData?.exportCode}
          </span>
        </div>
      ),
    },
    {
      title: 'Description',
      field: 'exportDescription',
    },
    {
      title: 'Interchange Control Number',
      field: 'interchangeControlNumber',
    },
    {
      title: 'Hospital Name',
      field: 'hospitalName',
    },
    {
      title: 'Info ReceiverId',
      field: 'infoReceiverId',
    },
    {
      title: 'Hospital City',
      field: 'hospitalCity',
    },
    {
      title: 'Hospital State',
      field: 'hospitalState',
    },
    {
      title: 'Hospital Zip',
      field: 'hospitalZip',
    },

    // {
    //   title: "Type",
    //   field: "dmType",
    // },
    // {
    //   title: "Client Code ",
    //   field: "clientNumber",
    //   cellStyle: {
    //     maxWidth: 150,
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   },
    //   render: (rowData) => {
    //     return (
    //       <Tooltip title={rowData?.clientNumber?.split(",").join(", ")}>
    //         <span>{rowData?.clientNumber?.split(",").join(", ")}</span>
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   title: "Created For",
    //   field: "createdFor",
    // },

    // {
    //   title: "Created By",
    //   field: "createdBy",
    // },
    // {
    //   title: "Date Created",
    //   field: "createdDate",
    //   render: (rowData) => {
    //     return rowData?.createdDate ? moment(rowData?.createdDate).format("MM/DD/YYYY") : "";
    //   },
    // },
    // {
    //   title: "Updated Date",
    //   field: "updatedDate",
    //   render: (rowData) => {
    //     return rowData?.updatedDate
    //       ? moment(rowData?.updatedDate).tz("America/New_York").format("MM/DD/YYYY hh:mm:ss A")
    //       : "";
    //   },
    // },
    // {
    //   title: "Status",
    //   field: "isDraft",
    //   render: (rowData) =>
    //     rowData?.isDraft === "Y" ? (
    //       <div class="completed-status status">
    //         <span style={{ color: "#ff8b00", fontWeight: "bold" }}>Draft</span>
    //       </div>
    //     ) : (
    //       <div class="completed-status status" style={{ fontWeight: "bold", color: "#00af00" }}>
    //         <span>Completed</span>
    //       </div>
    //     ),
    // },
  ];
  useEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [exportManager]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    dispatch(resetDataManager());
    dispatch(resetRecordData());
    dispatch(setParentRecordException(null));
    dispatch(resetDataManagerRecord());
  }, []);
  useEffect(() => {
    if (!importFileOpen || !exportFileOpen) {
      dispatch(resetDataManager());
    }
  }, [!importFileOpen, !exportFileOpen]);
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2000);
    }
  }, [tstmsg, deleteErrorMsg]);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        handleImportFileClose();
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);
  useEffect(() => {
    if (exportFileSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        handleExportFileClose();
      }, 2000);
    }
  }, [basicInfoErrorMsg, exportFileSuccessMsg]);
  useEffect(() => {
    if (addBasicInfoStatus === 200 && basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        setValue(1);
      }, 2000);
    }
  }, [addBasicInfoStatus, basicInfoSuccessMsg]);

  const handleClose = () => {
    setIsDelete(false);
  };
  const handleCopyDataManager = () => {
    setCopyDataManager(false);
  };
  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };
  const handleReportHistory = () => {
    setDmExecution(false);
  };
  const handleTest = (rowData) => {
    setRowData(rowData);
    setTestOpen(true);
  };
  const handleImportFile = (rowData) => {
    setRowData(rowData);
    setImportFileOpen(true);
  };
  const handleExportFile = (rowData) => {
    setRowData(rowData);
    setExportFileOpen(true);
  };
  const handleSubmit = () => {
    httpGet(`edi270export/delete/ediexport/${deletedId.current?.exportCode}`)
      .then((response) => {
        console.log(response, 'delresponse');
        if (response?.status === 200) {
          setToastMsg(response?.message);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      if (exportManager) {
        dispatch(fetchCreatedForDropDownData('exportmanager'));
        dispatch(fetchCreatedByDropDownData('exportmanager'));
      } else {
        dispatch(fetchCreatedForDropDownData('importmanager'));
        dispatch(fetchCreatedByDropDownData('importmanager'));
      }
      setStatus(false);
    }
  }, [status]);
  const handleTestClose = () => {
    setTestOpen(false);
  };
  const handleImportFileClose = () => {
    setImportFileOpen(false);
  };
  const handleExportFileClose = () => {
    setExportFileOpen(false);
  };

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl || (configurationUrl && !dmExecution)) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const IMDataSessionStorage = exportManager ?
    JSON.parse(sessionStorage.getItem('EMSearchData')) :
    JSON.parse(sessionStorage.getItem('IMSearchData'));
  if (IMDataSessionStorage && !submit) {
    searchData = IMDataSessionStorage;
  }
  const handleEdit = (rowData) => {
    dispatch(fetchBasicInfoData({code: rowData?.exportCode}));
    setValue(1);
    setEditExisting(exportManager ? 'Export Manager' : 'Import Manager');
  };
  const handleCopy = (rowData) => {
    setOldDmCodeData(rowData);
    setCopyDataManager(true);
  };

  const handleExecution = (rowData) => {
    setDmExecution(true);
    rowDataRef.current = rowData;
  };
  const handleDelete = (rowData) => {
    deletedId.current = rowData;
    setIsDelete(true);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setDmData(rowData);
  };
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={exportManager ? 'Export Manager' : 'Import Manager'}
        dmExecution={dmExecution}
      />

      <DialogBox
        open={dmExecution}
        dialogClose={handleReportHistory}
        title="Export Execution History"
        maxWidth="xl"
        hideFooter={true}
      >
        <DmExecutionTable
          executionRowData={rowDataRef?.current}
          type={'Export'}
          dmExecution={dmExecution}
        />
      </DialogBox>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={`Delete Export`}
        value={`Are you sure you want to delete the ${deletedId.current?.exportCode} Export?`}
        handleSubmit={handleSubmit}
      />
      <DialogBox
        open={copyDataManager}
        dialogClose={handleCopyDataManager}
        title={`Copy Export`}
        maxWidth="md"
        hideFooter={true}
      >
        <CopyDataManager oldDmCodeData={oldDmCodeData} type={type} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title={`Export Notes`}
        maxWidth="lg"
      >
        <DmNotes dmData={dmData} DataManagerAccess={DataManagerAccess} type={'ediExport'} />
      </DialogBox>
      <Grid item xs={12}>
        <div
          className={
            isSchedular ?
              'custom-table global-field-table custom-toolbar-icons custom-actions-icon  new-standard-textfields' :
              'custom-table global-field-table custom-toolbar-icons  custom-actions-icon  new-standard-textfields action-button'
          }
        >
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                setSubmit(false);
                const url = `edi270export/search/all`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  exportCode: searchData?.code ? searchData?.code : '',
                  exportDescription: searchData?.description ? searchData?.description : '',
                  infoReceiverId: searchData?.infoReceiverId ? searchData?.infoReceiverId : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                queryRef.current = query;
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isSchedular,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              isSchedular ?
                [] :
                [
                  {
                    icon: () => <SaveIcon />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => console.log(rowData, 'rowData'),
                  },
                ]
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  {!isSchedular && (
                    <div className="mt-2">
                      {/* <Button
                        type="button"
                        variant="outlined"
                        disabled={resultCount === 0}
                        className={`search-btn ml-2 ${classes.buttonRoot}`}
                        onClick={() => {
                          dispatch(
                            postPrintImportMaster(
                              {
                                dmCode: searchData?.dataManagerCode
                                  ? searchData?.dataManagerCode
                                  : "",
                                createdDate: searchData?.createdDate
                                  ? moment(searchData?.createdDate).format("MM/DD/YYYY")
                                  : "",
                                dmType: searchData?.dataManagerType?.value
                                  ? searchData?.dataManagerType?.value
                                  : "",
                                dmDescription: searchData?.dataManagerDescripton
                                  ? searchData?.dataManagerDescripton
                                  : "",
                                isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : "",
                                createdFor: searchData?.createdFor ? searchData.createdFor : "",
                                orderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field
                                    ? queryRef.current.orderBy.field
                                    : "",
                                orderDirection: queryRef.current?.orderDirection
                                  ? queryRef.current?.orderDirection
                                  : "",
                                clientNumber: searchData?.clientCode?.clientNumber
                                  ? searchData?.clientCode?.clientNumber
                                  : "",
                                createdBy: searchData?.createdBy ? searchData?.createdBy : "",
                                type: type,
                              },
                              type
                            )
                          );
                        }}
                      >
                        {downloadButton}
                      </Button> */}
                    </div>
                  )}
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleTest={handleTest}
                  // handleUsage ={handleUsage}
                  handleImportFile={handleImportFile}
                  handleExportFile={handleExportFile}
                  handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: false,
                    test: true,
                    notes: false,
                    execution: false,
                    usage: true,
                    user: true,
                    password: true,
                    delete: false,
                    importFile: false,
                    exportFile: true,
                  }}
                  disableMenu={{
                    disableEdit: false,
                    disableRun: false,
                    disableCopy: false,
                    disableDelete: false,
                    disableExecution: false,
                    disableNotes: false,
                    disableTest: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableImportFile: false,
                    disableExportFile: false,
                  }}
                />
              ),
            }}
          />
        </div>
        <DialogBox
          open={testOpen}
          dialogClose={handleTestClose}
          title={
            <div className="dialog-breadcrum">
              <p className="dialoge-title-breadcrum">
                <b>Test</b>
              </p>
              <BreadCrums
                name={'Code'}
                code={rowData?.dmCode}
                description={'Description'}
                descriptionValue={rowData?.dmDescription}
              />
            </div>
          }
          maxWidth="md"
          hideFooter={true}
        >
          <EnableTestDialoge
            setTestOpen={setTestOpen}
            rowData={rowData}
            resetBasicInfo={resetBasicInfo}
            type={type}
          />
        </DialogBox>
        <DialogBox
          open={importFileOpen}
          dialogClose={handleImportFileClose}
          title={
            <div className="dialog-breadcrum">
              <p className="dialoge-title-breadcrum">
                <b>Import File</b>
              </p>
              <BreadCrums
                name={'Code'}
                code={rowData?.dmCode}
                description={'Description'}
                descriptionValue={rowData?.dmDescription}
              />
            </div>
          }
          maxWidth="md"
          hideFooter={true}
        >
          <EnableTestDialoge
            setTestOpen={setImportFileOpen}
            rowData={rowData}
            resetBasicInfo={resetBasicInfo}
            importFile={true}
          />
        </DialogBox>
        <DialogBox
          open={exportFileOpen}
          dialogClose={handleExportFileClose}
          title="Run Export"
          maxWidth="md"
          hideFooter={true}
        >
          <ExportFile
            setExportFileOpen={setExportFileOpen}
            rowData={rowData}
            resetBasicInfo={resetBasicInfo}
            exportFile={true}
          />
        </DialogBox>
      </Grid>
      {(isBasicInfoLoading || loading) && <PageLoader />}
      {(deleteErrorMsg || basicInfoErrorMsg) && (
        <ErrorSnackbar errorMsg={deleteErrorMsg || basicInfoErrorMsg} />
      )}
      {(tstmsg || basicInfoSuccessMsg || exportFileSuccessMsg) && (
        <SuccessSnackbar successMsg={tstmsg || basicInfoSuccessMsg || exportFileSuccessMsg} />
      )}
    </>
  );
}

export default SearchDMTable;
